import { type ProgrammaticMessageOptions } from '@air/feature-ag-ui-chat';

const transformDeliveryIndexByThread = new Map<string, number>();

/** Resets per-thread sequencing when a new agent run starts on the thread. */
export const resetTransformTargetSourceNodeId = (threadId: string): void => {
  transformDeliveryIndexByThread.delete(threadId);
};

export const getResultsPerTarget = (programmaticOptions: ProgrammaticMessageOptions): number => {
  if (programmaticOptions.actionName === 'imageToVideo') {
    return programmaticOptions.variantCount ?? 1;
  }

  return 1;
};

/**
 * Picks the programmatic `sourceNodeId` for one `file_edit_complete` in a joined
 * multi-target transform. Each target may receive several results (e.g. animate
 * variant count); single-target sends keep `sourceNodeId`.
 */
export const consumeTransformTargetSourceNodeId = (
  threadId: string,
  programmaticOptions: ProgrammaticMessageOptions | undefined,
): string | undefined => {
  const targetNodeIds = programmaticOptions?.transformTargetNodeIds;

  if (!targetNodeIds || targetNodeIds.length <= 1) {
    return programmaticOptions?.sourceNodeId ?? programmaticOptions?.sourceNode?.group.id;
  }

  const resultsPerTarget = getResultsPerTarget(programmaticOptions);
  const deliveryIndex = transformDeliveryIndexByThread.get(threadId) ?? 0;
  const targetIndex = Math.floor(deliveryIndex / resultsPerTarget);

  transformDeliveryIndexByThread.set(threadId, deliveryIndex + 1);

  if (targetIndex >= targetNodeIds.length) {
    return undefined;
  }

  return targetNodeIds[targetIndex];
};
